<template>
  <article
    v-if="currentPage && currentPage.protection.locked === false"
    class="single-attachment"
    id="attachment-page"
  >
    <PageHeader />
    <DynamicHtml
      class="padding_large"
      v-observe-visibility="visibilityChanged"
      :class="[baseAnimation]"
      role="content"
      >{{ currentPage.description.rendered }}</DynamicHtml
    >
  </article>
  <PassProtected
    v-else-if="currentPage && currentPage.protection.locked === true"
  >
  </PassProtected>
</template>

<script>
export default {
  name: "single-attachment",
  components: {},
  data() {
    return {};
  },
  computed: {}
};
</script>
